import React from 'react';

import classes from './CompanySubLogo.module.scss';
import { SwymoLogo } from '../../SwymoLogo/SwymoLogo';

type CompanySubLogoProps = {
  logoUrl: string;
};

const CompanySubLogo = ({ logoUrl }: CompanySubLogoProps) => {
  return (
    <div className={classes.box}>
      <img src={logoUrl} alt="logo" className={classes.entityLogo} />
      <div className={classes.separatorLine} />
      <SwymoLogo variant="white" className={classes.logo} />
    </div>
  );
};

export { CompanySubLogo };
